import { render, staticRenderFns } from "./Promo.vue?vue&type=template&id=6f46e101&functional=true&"
import script from "./Promo.vue?vue&type=script&lang=ts&"
export * from "./Promo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports